import React from 'react';
import { Grid } from '@mui/material';

import { CardPayment, CommonCard } from '@organisms';

import { ReactComponent as IconTeam } from '@assets/svg/team.svg';
import { ReactComponent as IconLicensed } from '@assets/svg/licensed.svg';
import { ReactComponent as IconPaidDate } from '@assets/svg/paid-date.svg';
import { ReactComponent as IconLicensedCircles } from '@assets/svg/licensed-circles.svg';
import { ReactComponent as IconCardCircles } from '@assets/svg/card-circles.svg';
import { DateTime } from 'luxon';

interface CardListProps {
  licensed: number;
  active: number;
  license?: License;
}

const CardList: React.FC<CardListProps> = ({ licensed, active, license }: CardListProps) => {
  const startDate = license?.startDate;
  const endDate = license?.endDate;

  return (
    <Grid container columnSpacing={4}>
      <Grid item sm={12} md={4}>
        <CommonCard
          title="Current active users"
          count={active}
          icon={<IconTeam />}
          accent="success"
        />
      </Grid>
      <Grid item sm={12} md={4}>
        <CommonCard
          title="Current Active Licences"
          count={licensed}
          icon={<IconLicensed />}
          accent="info"
        />
      </Grid>
      <Grid item sm={12} md={4}>
        <CommonCard
          title="Paid till date"
          count={endDate ? DateTime.fromISO(endDate).toFormat('dd LLL yyyy') : ''}
          icon={<IconPaidDate />}
          accent="neutral"
        />
      </Grid>
      <Grid item sm={12} md={6} mt={4}>
        <CardPayment
          title="Current subscription plan"
          subtitle={`From ${
            startDate ? DateTime.fromISO(startDate).toFormat('dd LLL yyyy') : ''
          } to ${endDate ? DateTime.fromISO(endDate).toFormat('dd LLLL yyyy') : ''}`}
          count={`£${Number(license?.amount ?? 0).toFixed(2)}`}
          icon={<IconLicensedCircles />}
          bgColor="#F5CB5C"
        />
      </Grid>
      <Grid item sm={12} md={6} mt={4}>
        <CardPayment
          title="Next payment"
          subtitle={`on ${endDate ? DateTime.fromISO(endDate).toFormat('dd LLLL yyyy') : ''}`}
          count={`£${Number(license?.amount ?? 0).toFixed(2)}`}
          icon={<IconCardCircles />}
        />
      </Grid>
    </Grid>
  );
};

export default CardList;
